import React from 'react';
import { Link } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import ParticlesBG from '../../Shared/ParticlesBG';
import CAMPAIGN_SIMULATOR_GUIDE from './campaignSimulatorGuideContent';
import '../../Assets/Stylesheets/Pages/Resources.scss';

export default function CampaignSimulatorDocs() {
  return (
    <div className="resources-page technical-docs-page">
      <ParticlesBG />

      <div className="resources-hero">
        <div className="container">
          <h6>TECHNICAL DOCS</h6>
          <h1>
            Campaign <span className="gradient-text">Simulator</span>
          </h1>
          <p className="subtitle">
            Quick Run vs Full Analysis, input glossary, stochastic settings, and export reference.
          </p>
          <p>
            <Link to="/resources">← Back to Resources</Link>
          </p>
        </div>
      </div>

      <div className="resources-content">
        <div className="container technical-docs-content">
          <ReactMarkdown remarkPlugins={[remarkGfm]}>{CAMPAIGN_SIMULATOR_GUIDE}</ReactMarkdown>
        </div>
      </div>
    </div>
  );
}
